import { Game } from 'model/game/types';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Return a new object that omits any PGN headers that are unset (i.e they have their default value).
 */
export function removeUnsetHeaders(headers: JCE.PGNHeaders) {
  return (<(keyof JCE.PGNHeaders)[]>Object.keys(headers)).reduce<JCE.PGNHeaders>(
    (acc, key) => {
      if (
        headers[key] !== Game.EmptyPGNHeaders.Value &&
        headers[key] !== Game.EmptyPGNHeaders.Date
      ) {
        acc[key] = headers[key];
      }

      return acc;
    },
    <JCE.PGNHeaders>{},
  );
}
